<template>
  <div class="PsPatientWeekend">
    <div class="row">
      <div class="row rowTitle">Resumen mensual</div>
      <ps-patient-btn-new-weekend></ps-patient-btn-new-weekend>
    </div>
    <div class="container">
      <div
        class="item"
        v-for="(weekend, index) in patient.weekends"
        :key="index"
      >
        {{ weekend.description }}
        <i class="icon el-icon-edit" @click="editItem(weekend)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import PsPatientBtnNewWeekend from "./PsPatientBtnNewWeekend.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "PsPatientWeekend",
  components: { PsPatientBtnNewWeekend },
  computed: {
    ...mapState("patients", ["patient"])
  },
  methods: {
    ...mapMutations("patients", [
      "PATIENTS_ITEM_WEEKEND",
      "PATIENTS_DIALOG_WEEKEND"
    ]),
    editItem(weekend) {
      this.PATIENTS_ITEM_WEEKEND(
        JSON.parse(JSON.stringify(weekend))
      );
      this.PATIENTS_DIALOG_WEEKEND(true);
    }
  }
};
</script>

<style scoped>
.PsPatientWeekend {
  background-color: white;
  border-radius: 20px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  width: 48%;
  margin-top: 35px;
  min-height: 200px;
  max-height: 400px;
  overflow: auto;
}
.rowTitle {
  font-size: 24px;
  font-weight: bold;
  line-height: 35px;
  align-items: center;
}
.week {
  justify-content: space-between;
}
.day {
  font-size: 20px;
  font-weight: 500;
  color: #efaf00;
}
.weight {
  font-size: 16px;
  font-weight: 500;
}
.column {
  height: 55px;
  justify-content: space-between;
}
.week .column {
  align-items: center;
}
.item {
  width: 100%;
  text-align: left;
  padding-bottom: 4px;
  margin-bottom: 8px;
  word-wrap: break-word;
  border-bottom: 1px solid #ccc;
}
.icon {
  line-height: 30px;
  margin-left: 10px;
  cursor: pointer;
  transition: 0.2s ease;
}
.icon:hover {
  font-size: 1.1rem;
  font-weight: bold;
}

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
  .PsPatientWeekend {
    width: 100%;
  }
}
</style>
